import React from 'react';
import { User } from '../User';

const Secure = (authority, component ) => {
    if(User.hasAuthority(authority)){
        return component
    }
    return <></>
}
export default Secure;